import { Component } from "@theme/component";
import { ShowStatusMessageEvent, ThemeEvents } from "@theme/events";

class StatusBarComponent extends Component {
  /**
   * @param {ShowStatusMessageEvent} event
   */
  #callback = (event) => this.#handleShowMessage(event);

  connectedCallback() {
    window.addEventListener(ThemeEvents.showStatusMessage, this.#callback);
  }

  disconnectedCallback() {
    window.removeEventListener(ThemeEvents.showStatusMessage, this.#callback);
  }

  /**
   * Display the status message given in the event
   *
   * @param {ShowStatusMessageEvent} event
   */
  #handleShowMessage(event) {
    const templateBinding = `${event.detail.binding}:template`;
    const templateElement = this.parentElement?.querySelector(`[data-bind="${templateBinding}"]`);
    if (!(templateElement instanceof HTMLTemplateElement)) throw new Error('Status message required');

    const node = templateElement.content.firstElementChild?.cloneNode(true);
    if (!node) throw new Error("Failed to clone status message");

    const contentContainer = this.querySelector('[ref="messageContent"]');
    if (!contentContainer) throw new Error("Status message container required");

    contentContainer.replaceChildren(node);

    this.setAttribute('status_style', event.detail.style);
    this.classList.add('show');

    const expire = templateElement.dataset.expire ? parseInt(templateElement.dataset.expire) : 0;
    if (expire > 0) {
      setTimeout(() => {
        this.classList.remove('show');
      }, expire * 1000);
    }
  }
}

if (!customElements.get('status-bar-component')) {
  customElements.define('status-bar-component', StatusBarComponent);
}
